<template>
  <div v-show="headerShow" class="navbar" :class="selected ? 'sel' : ''">
    <div class="logo-contain">
      <logo-show class="log-show" :selected="selected"></logo-show>
    </div>
    <div ref="menu" class="menu-contain">
      <div v-for="(item, index) in menuItems" @click="goTo(item)" :key="index" class="menu-item" :class="item.selected ? 'selected' : ''">
        {{ item.label }}
        <div class="submenu-contain">
          <div class="submenu" v-if="item.children.length">
            <div class="sub-left">
              <div class="left-title">
                <div>
                  {{ item.label }}
                </div>
                <img loading="lazy" style="width: 40px" :src="left" />
              </div>
              <div class="left-details">
                <div v-for="(subItem, subIndex) in item.children" @click.stop="scrollToElementWithOffset(subItem, item)" :key="subIndex" class="submenu-item">
                  <img loading="lazy" :src="ja" class="icon-show" /> <span>{{ subItem.name }}</span>
                </div>
              </div>
            </div>
            <div class="sub-right">
              <div class="submenu-item">
                <img loading="lazy" :src="ja" class="icon-show" /> <span>二十年汇东</span>
                <div style="margin-left: 50px">打造让老百姓放心品牌</div>
                <img loading="lazy" class="sub-img" :src="gswj" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="eng" @click="toEngPage()">English</div>
  </div>
</template>

<script>
  import logoShow from '../components/logoShow';
  import headerMixin from '../components/headerMixin';
  import left from '@/assets/imgs/baseIcon/circle-left.png';
  import ja from '@/assets/imgs/baseIcon/ja.png';
  import gswj from '@/assets/imgs/about_des.jpg';

  import scrollEvent from './pages/scrollEvent';
  export default {
    components: {
      logoShow
    },
    mixins: [scrollEvent, headerMixin],
    data() {
      return {
        activeIndex: -1,
        menuItems: [
          { label: '首页', router: 'home' },
          { label: '关于汇东', router: 'about', children: [] },
          { label: '产品中心', router: 'productCenter', children: [] },
          { label: '研发中心', router: 'rdCenter', children: [] },
          { label: '新闻资讯', router: 'newsList', children: [] },
          { label: '解决方案', router: 'solution', children: [] },
          {
            label: '联系我们',
            router: 'contactUs',
            children: []
          }
        ],
        left,
        ja,
        gswj,
        // gswj: 'https://hd-imgs.oss-cn-qingdao.aliyuncs.com/%E4%B8%BB%E9%A2%98%E8%83%8C%E6%99%AF/%E5%85%AC%E5%8F%B8%E5%A4%96%E6%99%AF%E7%85%A7%E7%89%87.jpg',
        timer: undefined,
        headerShow: true,
        selected: false,
        titleList: []
      };
    },
    watch: {
      // 监听所有路由变化
      $route(to, from) {
        this.setSel(to.name);
      }
    },
    created() {
      this.menuItems.map((item) => {
        item.children = this.routeData[item.router] || [];
      });
    },
    mounted() {
      this.setSel(this.$route.name);
    },
    methods: {
      toEngPage(){
        window.location.href = 'https://www.guanshanindustry.com';
      },
      scrollToElementWithOffset(item, routerInfo) {
        this.$router.push({ name: routerInfo.router, query: { moduleName: item.moduleName } });
        setTimeout(() => {
          this.$nextTick(() => {
            const element = document.getElementById(item.moduleName);
            if (element) {
              // 获取目标元素相对于整个文档的位置
              const rect = element.getBoundingClientRect();
              // 滚动到目标元素位置，并加上偏移量
              window.scrollTo({
                top: rect.top + window.scrollY - 90,
                behavior: 'smooth'
              });
            }
          });
        }, 500);
      },
      goTo(item) {
        if (item.router != this.$route.name) {
          this.$router.push({ name: item.router });
        }
      },
      setSel(name) {
        this.menuItems.map((item) => {
          if (name === item.router) {
            item.selected = true;
          } else {
            item.selected = false;
          }
        });
        this.menuItems = [...this.menuItems];
      },
      afterScroll(flag) {
        if (this.$route.name === 'home') {
          this.headerShow = true;
        } else {
          this.headerShow = !flag;
        }

        if (window.scrollY > 150) {
          this.selected = true;
        } else {
          this.selected = false;
        }
      }
    }
  };
</script>
<style lang="less" scoped>
  .navbar {
    font-family: syht-Medium-5;
    display: flex;
    width: 100%;
    min-width: 1000px;
    justify-content: space-between;
    align-items: center;
    background-color: transparent;
    padding: 0 100px;
    position: fixed;
    z-index: 9;
    height: 90px;
    color: #fff;
    font-size: 18px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), /* 主要阴影 */ 0 1px 2px rgba(0, 0, 0, 0.05); /* 较小的次要阴影 */
  }
  .navbar:hover {
    color: #000;
    background-color: white;
  }
  .navbar.sel {
    color: #000;
    background-color: white;
  }
  .logo-contain {
    flex: 0 0 100px;
  }
  .menu-contain {
    display: flex;
    height: 100%;
    line-height: 100px;
    position: relative;
  }
  .eng {
    position: absolute;
    top: 10px;
    right: 15px;
    cursor: pointer;
    &:hover {
      color: rgb(80, 193, 213);
    }
  }
  .menu-item {
    position: relative;
    cursor: pointer;
    transition: color 0.3s ease;
    padding: 0 20px;
    &::after {
      content: '';
      width: 0;
      height: 3px; /* 指示线的高度 */
      background-color: #d7b882; /* 指示线的颜色 */
      transition: width 0.3s ease;
      position: absolute;
      bottom: 20px;
      left: 0;
      right: 0; /* 确保指示线段宽度为100% */
      margin: auto; /* 居中对齐 */
    }
    &:hover::after,
    &.selected::after {
      width: 75px; /* 当悬停或选中时，指示线扩展到整个宽度 */
    }
  }
  .submenu-contain {
    display: none;
    line-height: 40px;
  }
  .menu-item:hover .submenu-contain {
    display: block;
  }
  .submenu {
    position: fixed; /* 更改为固定定位 */
    top: 100px; /* 自动计算顶部位置 */
    right: 30px;
    width: 1000px; /* 固定宽度 */
    background-color: #f7f7f7;
    color: #000;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: opacity 0.3s ease, transform 0.3s ease;
    z-index: 10;
    display: flex;
    padding: 50px;
    > .sub-left {
      display: flex;
      align-items: center;
      flex: 1;
      .left-title {
        margin-right: 10px;
        flex: 1;
        font-size: 24px;
        text-align: center;
      }
      .left-details {
        flex: 2;
        text-align: left;
      }
    }
    > .sub-right {
      flex: 1;
      border-left: 1px solid #999;
    }
  }

  .submenu-item {
    padding: 6px 10px;
    color: black;
    cursor: pointer;
    .icon-show {
      height: 40px;
      width: 64px;
      display: inline-block;
      margin-right: 10px;
    }
    .sub-img {
      margin-left: 50px;
      margin-top: 30px;
      width: 300px;
      border-radius: 30px;
    }
  }
  // .submenu-item:last-child {
  //   border-bottom: none;
  // }
  .submenu-item:hover {
    background-color: #f0f0f0;
  }
</style>
